/**
 * Shared type helper utilities for platform generators
 */

/**
 * Returns true if the given TS type string represents an untyped object
 * that should be treated as a generic dictionary/map on native bridges.
 *
 * Supported aliases:
 * - '{}' (empty inline object)
 * - 'AnyObject' (explicit alias used in specs to mean dictionary-like)
 *
 * Note: 'any' is NOT included here because it can represent any type
 * (including arrays, primitives), not just objects/dictionaries.
 */
export function isAnyObjectType(tsType: string | undefined | null): boolean {
  const t = String(tsType || "").trim();
  return t === "{}" || t === "AnyObject";
}

/**
 * Returns true if the given TS type string represents the Any type.
 *
 * The Any type can represent any value (primitives, arrays, objects, etc.)
 * and should not be converted on native bridges - it's already in the correct format.
 *
 * Supported values:
 * - 'Any' (TypeScript alias from brick-module)
 * - 'any' (TypeScript built-in)
 */
export function isAnyType(tsType: string | undefined | null): boolean {
  const t = String(tsType || "").trim();
  return t === "Any" || t === "any";
}
